import css from './Ticket.module.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { BalloonSize, BalloonTipPosition, ComponentColor } from 'meta/backendControlled/structure'
import { Breakpoints } from 'meta/layout/breakpoints'
import { ITicket } from 'meta/pages/tickets'

import BalloonWrapper from 'components/Layout/BalloonWrapper'
import { GridColumn } from 'components/Layout/Grid'

import { ITicketsFormFields } from '../types'
import TicketFormFields from './TicketFormFields'
import TicketInfo from './TicketInfo'

interface IPropsTicket {
  formFields: ITicketsFormFields
  idx: number
  ticket: ITicket
}

const Ticket: React.FC<IPropsTicket> = (props) => {
  const { formFields, idx, ticket } = props

  const { t } = useTranslation()

  return (
    <GridColumn
      className={css.ticket}
      id={`${idx}_${ticket.id}`}
      gridColumnStart={{ [Breakpoints.mobile]: 1, [Breakpoints.tablet]: 4, [Breakpoints.laptop]: 4 }}
      gridColumnEnd={{ [Breakpoints.mobile]: 17, [Breakpoints.tablet]: 14, [Breakpoints.laptop]: 14 }}
    >
      {ticket.isFirstOfGroup && <h2>{ticket.details}</h2>}

      <BalloonWrapper color={ComponentColor.white} tipPosition={BalloonTipPosition.right} size={BalloonSize.small}>
        <div className={css.ticket__content}>
          {ticket.isPartOfGroup ? (
            <h5>{`${String(t('form:customer_name'))} #${String(ticket.positionInGroup)}`}</h5>
          ) : (
            <TicketInfo ticket={ticket} />
          )}
          <TicketFormFields formFields={formFields} idx={idx} ticket={ticket} noPadding={ticket.isPartOfGroup} />
        </div>
      </BalloonWrapper>
    </GridColumn>
  )
}

export default Ticket
